export default __webpack_public_path__ + "static/media/icon_notebook_yellow.622ef5a7.svg";